<template>
  <CardContainer>
    <Header v-if="header" :icon="header.icon">{{ header.title }}</Header>

    <hr class="col-xs-12" />

    <b-alert
      v-for="message in messages"
      :key="message.name"
      show
      :variant="message.variant">
      {{ message.label }}
    </b-alert>

    <b-form @submit="on_submit" novalidate>
      <b-row>
        <b-col class="col-12">
          <vue-form-generator
            ref="vfgForm"
            :model="model"
            :schema="schema"
            :options="options"
            tag="div">
          </vue-form-generator>
        </b-col>
      </b-row>

      <hr class="col-xs-12" />

      <FormButtons
        :buttons="buttons"
        @button_click="button_click"></FormButtons>
    </b-form>
  </CardContainer>
</template>

<script>
import VueFormGenerator from "vue-form-generator";
import FormButtons from "./FormButtons";
import Header from "./Header";
import CardContainer from "./CardContainer";

export default {
  name: "Form",
  components: {
    "vue-form-generator": VueFormGenerator.component,
    FormButtons,
    Header,
    CardContainer
  },
  methods: {
    on_submit: async function (event) {
      event.preventDefault();
      const validation_result = await this.$refs.vfgForm.validate();

      this.$refs.vfgForm._props.options.validateAfterChanged = true;

      if (this.did_validation_succeed(validation_result)) {
        this.$emit("form_submit", this.model);
      }
    },
    did_validation_succeed: function (result) {
      /* Checks whether the form validation was successful. True and an
      empty array mean that the validation succeeded. The result type
      depends on whether validateAsync is enabled on the form. */

      if (result === true || (Array.isArray(result) && !result.length)) {
        return true;
      }
      return false;
    },
    button_click: function (button_name) {
      this.$emit("button_click", button_name);
    }
  },
  props: {
    header: {
      title: String,
      icon: String
    },
    model: Object,
    schema: Object,
    options: Object,
    buttons: Array,
    messages: Array
  }
};
</script>
